// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"6bdb4320","69":"914b6f6f","423":"fe4dd9eb","461":"b3ac8035","557":"ee232f74","626":"1780e668","653":"c9f1cf82","699":"4a0fc183","832":"ac0062ab","925":"956cdabd","973":"844bf609"}[chunkId] + ".chunk.js";
};